import React, { useState } from 'react';
import SideBarContainer from 'Containers/SideBarContainer';
import Edit from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { useLocation } from 'react-router-dom';
import { userEvaluationPublish } from 'Api/courseDetailsEvaluations';
import Alert from 'Components/Alert';
import Search from '../../Components/Search';
import useTranslation from '../../Hooks/useTranslation';
import DropDown from '../../Components/DropDown';
import useDropDown from './Hooks/useDropdown';
import useFetch from './Hooks/useFetch';
import useComponent from './Hooks/useComponent';
import useRestartEvaluation from './Hooks/useRestartEvaluation';
import useConfirmationModal from './Hooks/useConfirmationModal';
import useEvaluation from './Hooks/useEvaluation';

import {
  Header,
  HeaderContent,
  HeaderIcon,
  HeaderInfo,
  EvaluationTitle,
  EvaluationSubTitle,
  EditEvaluationIcon,
  SearchContainer,
  Content,
  FiltersContainer,
  DropDownsContainer,
  publishButton,
  ButtonContainer,
  saveButton,
  disabledButton,
  disabledPublishButton,
} from './style';

export default function Evaluations() {
  const location = useLocation();
  const evaluation = location?.state?.evaluation;
  const courseId = location?.state?.courseId;
  const [isLoading, setIsLoading] = useState(true);
  const { t2 } = useTranslation('Evaluation');

  const {
    employees,
    setEmployees,
    unpublishedGrades,
    setUnpublishedGrades,
    departments,
    terminals,
    jobTitles,
    errors,
    setErrors,
  } = useFetch(
    {
      lessonId: evaluation.id,
      courseId,
    },
    setIsLoading
  );
  const { setSearch, setTerminal, setDepartment, setJobTitle, employeesFilters } = useDropDown({
    employees,
  });
  const titles = [t2('Terminal'), t2('Department'), t2('JobTitle')];
  const options = [terminals, departments, jobTitles];
  const methods = [setTerminal, setDepartment, setJobTitle];
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [editing, setEditing] = useState(false);

  const { thereIsComponent } = useComponent(
    editing,
    evaluation.id,
    setEmployees,
    employees,
    setUnpublishedGrades,
    unpublishedGrades,
    setErrors,
    errors
  );

  const { setOpenConfirmationModal, ConfirmationModal } = useConfirmationModal();

  const { confirmationRestartEvaluation, restartEvaluation } = useRestartEvaluation(
    setOpenConfirmationModal,
    setAlertOpen,
    setAlertMessage,
    setAlertError,
    employees,
    setEmployees,
    courseId
  );

  const { icon, typeLabel, table } = useEvaluation(
    evaluation,
    employeesFilters,
    thereIsComponent,
    isLoading,
    confirmationRestartEvaluation
  );

  const handleEdit = () => {
    setEditing(true);
  };

  const handleSave = () => {
    setEditing(false);
  };

  const handleSubmit = async () => {
    const response = await userEvaluationPublish({ lessonId: evaluation.id });
    if (response.status === 'success') {
      const gradesCopy = unpublishedGrades.map(item => (item ? false : item));
      setEmployees(employees);
      setAlertMessage(t2('AlertPublishSuccess'));
      setUnpublishedGrades(gradesCopy);
      setAlertOpen(true);
    } else {
      setAlertMessage(t2('AlertPublishError'));
      setAlertError(true);
      setAlertOpen(true);
    }
  };

  return (
    <SideBarContainer>
      <Header>
        <HeaderContent>
          <HeaderIcon>{icon}</HeaderIcon>
          <HeaderInfo>
            <EvaluationTitle>{evaluation.name}</EvaluationTitle>
            <EvaluationSubTitle>{typeLabel}</EvaluationSubTitle>
          </HeaderInfo>
          {!editing && (
            <EditEvaluationIcon onClick={handleEdit}>
              <Edit />
            </EditEvaluationIcon>
          )}
          {editing && (
            <ButtonContainer>
              <Button
                variant="contained"
                color="success"
                onClick={handleSave}
                style={!editing ? disabledButton : saveButton}
                disabled={!editing}
              >
                {t2('SaveAsDraft')}
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmit}
                style={!unpublishedGrades.includes(true) ? disabledPublishButton : publishButton}
                disabled={!unpublishedGrades.includes(true)}
              >
                {t2('PublishGrades')}
              </Button>
            </ButtonContainer>
          )}
        </HeaderContent>
      </Header>
      <br />
      <br />
      <Content>
        <FiltersContainer>
          <SearchContainer>
            <Search setData={setSearch} />
          </SearchContainer>
          <DropDownsContainer>
            {titles.map((title, index) => (
              <DropDown key={title + index} title={title} options={options[index]} setData={methods[index]} />
            ))}
          </DropDownsContainer>
        </FiltersContainer>
        <br />
        {table}
      </Content>
      <Alert message={alertMessage} open={alertOpen} setOpen={setAlertOpen} error={alertError} />
      <ConfirmationModal onAccept={restartEvaluation} />
    </SideBarContainer>
  );
}
